import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($options.currentComponent.name), _mergeProps($options.currentComponent.props, {
    key: $options.currentComponent.name
  }), null, 16 /* FULL_PROPS */))
}